import { Route, Routes } from 'react-router-dom';
import MatrixMappingPage from './MatrixMapping';
import MatrixMappingViewsPage from './MatrixMappingViews';

const MatrixMappingRouter: React.FC = () => {
  return (
    <Routes>
      <Route path='' element={<MatrixMappingPage />} />
      <Route path='views/:systemName/:jobNum' element={<MatrixMappingViewsPage />} />
    </Routes>
  );
};

export default MatrixMappingRouter;
